import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Web3Service } from 'src/app/core/services/web3.service';
import { environment } from 'src/environments/environment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
@Component({
  selector: 'app-convert-tokens',
  templateUrl: './convert-tokens.component.html',
  styleUrls: ['./convert-tokens.component.scss']
})
export class ConvertTokensComponent implements OnInit {
  clientDetails = environment.clientDetails;
  convertAmount: number;
  selectedToken: string;
  targetToken: string;
  availableBalance: number;
  exchangeRate: number = 0;
  sourceAmount: number = 0;
  isCalculating: boolean = false;
  isConverting: boolean = false;
  accountNumber: string = '';
  koBalance: number = 0;
  gflBalance: number = 0;
  enableConvert: boolean = false;
  cryptoAmount: number = 0;
  settingsData: any = {};
  errorMessage: string = '';

  constructor(
    public dialogRef: MatDialogRef<ConvertTokensComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private web3service: Web3Service,
    private ngxLoader: NgxUiLoaderService
  ) {
    this.selectedToken = data.selectedToken;
    this.targetToken = data.targetToken;
    this.cryptoAmount = data.cryptoAmount;
    console.log("data",data);
    if (this.selectedToken === 'KO+') {
      this.koBalance = this.availableBalance;
      this.gflBalance = 0;
    } else {
      this.gflBalance = this.availableBalance;
      this.koBalance = 0;
    }
  }


  async ngOnInit(): Promise<void> {
    this.convertAmount = this.data.tokensCount;
    this.settingsData=this.data.settingsData;
    this.addStyle();
    this.accountNumber = localStorage.getItem('WalletId');
    let erc20contract = this.web3service.getContract('ERC20');
    erc20contract.methods.balanceOf(this.accountNumber).call().then(resp => {
      const available_balance = Number(resp) / (10 ** 18);
      const crypto_balance = Math.trunc(available_balance * Math.pow(10, 3)) / Math.pow(10, 3);
      this.gflBalance = crypto_balance;
    });
    let kPerc20contract = this.web3service.getContract('ERC20_Kombat');
    kPerc20contract.methods.balanceOf(this.accountNumber).call().then(resp => {
      const available_balance = Number(resp) / (10 ** 18);
      const crypto_balance = Math.trunc(available_balance * Math.pow(10, 3)) / Math.pow(10, 3);
      this.koBalance = crypto_balance;
    });
    if (this.convertAmount && this.convertAmount > 0) {
      await this.onAmountChange();
    }
  }

  addStyle(){
    const dynamicColor = this.settingsData?.form_font_secondary_color ;
    document.documentElement.style.setProperty('--invalid-border-color', dynamicColor);
    document.documentElement.style.setProperty('--before-border-color', dynamicColor);
  }

  async onAmountChange(): Promise<void> {
    console.log("convertAmount",this.convertAmount, this.targetToken, this.selectedToken);
    if (!this.convertAmount || this.convertAmount <= 0) {
      return;
    }

    this.isCalculating = true;
    try {
      const result = await this.calculateTokenConversion(this.targetToken, this.convertAmount);
      this.sourceAmount = result.sourceAmount;
      this.exchangeRate = result.pricePerToken;
      console.log("amount", this.sourceAmount, this.koBalance, this.gflBalance);
      if(this.selectedToken === "GFL") {
        this.enableConvert = this.sourceAmount <= this.koBalance;
        this.errorMessage = this.sourceAmount <= this.koBalance ? '' : 'Insufficient ' + (this.clientDetails.name=="BigbeeAI"?"BB":"KO+") + ' balance for conversion';
      } else {
        this.enableConvert = this.sourceAmount <= this.gflBalance;
        this.errorMessage = this.sourceAmount <= this.gflBalance ? '' : 'Insufficient GFL balance for conversion';
      }
    } catch (error) {
      console.error('Error calculating conversion:', error);
    } finally {
      this.isCalculating = false;
    }
  }

  async onConvert(): Promise<void> {
    this.ngxLoader.start();
    console.log("convertAmount",this.convertAmount, this.targetToken, this.selectedToken);
    if (!this.convertAmount || this.convertAmount <= 0) {
      return;
    }

    this.isConverting = true;
    try {
      await this.executeTokenConversion(this.targetToken, this.sourceAmount);
      this.dialogRef.close({ 
        success: true, 
        selectedToken: this.selectedToken 
      });
    } catch (error) {
      console.error('Conversion failed:', error);
    } finally {
      this.isConverting = false;
      this.ngxLoader.stop();
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onExchange(): void {
    this.onConvert();
  }

  async calculateTokenConversion(tokenType: string, desiredAmount: number): Promise<{ sourceAmount: number, pricePerToken: number }> {
    const gflKPcontract = this.web3service.gflkp_exchangecontract;
    console.log("tokenType",tokenType,"desiredAmount",desiredAmount);
    try {
      const pricePerToken = await gflKPcontract.methods.pricePerToken().call();
      console.log("pricePerToken",pricePerToken);
      let sourceAmount: number;

      if (tokenType === 'KO+') {
        console.log("source amount",desiredAmount / Number(pricePerToken));
        sourceAmount = desiredAmount / Number(pricePerToken);
      } else if (tokenType === 'GFL') {
        sourceAmount = desiredAmount / Number(pricePerToken);
      } else {
        throw new Error('Invalid token type. Must be either "KO+" or "GFL"');
      }
      console.log("sourceAmount",sourceAmount,"pricePerToken",pricePerToken);
      return {
        sourceAmount,
        pricePerToken: Number(pricePerToken)
      };

    } catch (error) {
      console.error('Error calculating token conversion:', error);
      throw new Error('Failed to calculate token conversion');
    }
  }


  async executeTokenConversion(tokenType: string, amount: number): Promise<any> {
    const gflKPcontract = this.web3service.gflkp_exchangecontract;
    const gflkpaddress = this.web3service.Contracts_Rinkeby.GFL_KP_EXCHANGE_ADDRESS;
    const isConvertingToGFL = tokenType === 'KO+';
    const sourceToken = isConvertingToGFL ? 'KO+' : 'GFL';
    const targetToken = isConvertingToGFL ? 'GFL' : 'KO+';
    console.log("sourceToken",sourceToken,"targetToken",targetToken,"amount",amount);

    const erc20contract = isConvertingToGFL
      ? this.web3service.getContract('ERC20_Kombat')
      : this.web3service.getContract('ERC20');

    if (!erc20contract) {
      throw new Error('ERC20 contract is not available');
    }
    const amountInWei = this.web3service.convertPriceToEther(amount);

    try {
      console.log(`Approving ${sourceToken} transfer...`);
      const approvalTx = await erc20contract.methods
        .approve(gflkpaddress, amountInWei.toString())
        .send({ from: this.accountNumber });

      if (!approvalTx.status) {
        throw new Error('Token approval failed');
      }

      console.log('Approval successful, executing swap...');
      let swapTx;
      if (isConvertingToGFL) {
        console.log(`Converting ${amount} KO+ to GFL`);
        swapTx = await gflKPcontract.methods
          .purchaseGFL(amountInWei.toString())
          .send({ from: this.accountNumber });
      } else {
        console.log(`Converting ${amount} GFL to KO+`);
        swapTx = await gflKPcontract.methods
          .purchaseKP(amountInWei.toString())
          .send({ from: this.accountNumber });
      }

      if (!swapTx.status) {
        throw new Error('Token swap transaction failed');
      }

      console.log(`Token swap successful: ${amount} ${sourceToken} → ${targetToken}`, swapTx);
      return swapTx;

    } catch (error) {
      console.error(`Token conversion from ${sourceToken} to ${targetToken} failed:`, error);
      throw error;
    }
  }
}
